import { MatchKeysAndValues } from "../../../@components/interfaces";
import { NSCalendar } from "../../../pages/calendar/activities/calendar-month";
import { xget, xhttp } from "../Fetchv2.js";

export class Events {
	async toSnelX(data: any, token?: string) {
		let response = await xhttp<any>(`/events`, "POST", { token, data });
		return response;
	}

	async getEvents(pgid: string, yyyymm: number, token?: string) {
		let response = await xget<NSCalendar.iCalEvent[]>(`/pages/${pgid}/calendar/events`, { token, yyyymm });
		return response;
	}

	async createEvent(pgid: string, token: string, ob: NSCalendar.iCalEvent) {
		let response = await xhttp<{ insertedCount: number; _id: string }>(`/pages/${pgid}/calendar/events`, "POST", { event: ob, token });
		return response;
	}

	async getEvent(_id: string, pgid: string, token?: string) {
		const response = await xget<NSCalendar.iCalEvent>(`/pages/${pgid}/calendar/events/${_id}`);
		return response;
	}

	async editEvent(pgid: string, _id: string, ob: MatchKeysAndValues<NSCalendar.iCalEvent>) {
		let response = await xhttp<{ modifiedCount: number }>(`/pages/${pgid}/calendar/events/${_id}`, "PUT", ob);
		return response;
	}

	async deleteEvent(_id: string, pgid: string) {
		const response = await xhttp<{ ok: number | undefined; id: string }>(`/pages/${pgid}/calendar/events/${_id}`, "DELETE");
		return response;
	}
}
